import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CALENDLY_URL } from '../../data/foundingProgram';
type BookCallButtonProps = {
  children?: React.ReactNode;
  variant?: 'solid' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const sizes: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'px-5 py-3 text-[10px]',
  md: 'px-7 py-4 text-[11px]',
  lg: 'px-9 py-5 text-xs'
};
export function BookCallButton({
  children = 'Book a call with Ash',
  variant = 'solid',
  size = 'md',
  className = ''
}: BookCallButtonProps) {
  const palette = variant === 'solid' ? 'bg-[#D4AF37] text-[#08070A] hover:bg-[#E5C158]' : 'border border-[#D4AF37]/45 text-[#D4AF37] hover:border-[#D4AF37] hover:bg-[#D4AF37]/10';
  return <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap font-bold uppercase tracking-[0.22em] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FDFBF7] focus-visible:ring-offset-2 focus-visible:ring-offset-[#08070A] ${palette} ${sizes[size]} ${className}`} data-id="element-1348" data-mp="3ahbrli4dad00">
      {children}
      <ArrowRight className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-1349" data-mp="2ivkv3xud06gz" />
    </a>;
}